import React, { FC } from 'react'
import DealAuditLogContainer from 'containers/Deal/DealAuditLog'

const DealAuditLogPage: FC = () => <DealAuditLogContainer />

export default DealAuditLogPage
